export default (state) => ({
  isPushing: state.auth.isPushing,
  data: state.auth.data,
  error: state.auth.error,
});
